import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import { Card } from '../../../components/Card';
import { HBox } from '../../../components/Box';
import { IsClosed, IsOpen } from '../../../components/Icon';
import { CreditInfoVehiclesTable } from './CreditInfoVehiclesTable';
import { formatCurrency } from '../../../utils/string';
import styles from './CardCreditInfo.module.css';

const Container = styled.div`
  width: 100%;
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
  .wide {
    width: 100%;
    max-width: 800px;
    overflow-x: ${props => (props.itemsLength ? 'auto' : '')};
  }
`;

const STATE = {
  showDetails: false,
};

class CompanyCreditInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }
  render() {
    return (
      <Container>
        <Card className="vehicle-info-card info-card data wide" style={{ width: '100%' }}>
          <HBox vCenter>
            <h2>{this.lbl('invoice.details.card.credit_info_details')}</h2>
            {!this.state.showDetails ? (
              <div
                className="icon-block"
                onClick={() => {
                  this.setState({ showDetails: true });
                }}
              >
                <IsOpen />
              </div>
            ) : (
              <div
                className="icon-block"
                onClick={() => {
                  this.setState({ showDetails: false });
                }}
              >
                <IsClosed />
              </div>
            )}
          </HBox>

          {['credit_limit', 'used_credit_limit', 'remained_credit_limit'].map(property => {
            return (
              <div key={property} className={styles.containerLabel}>
                <div className={styles.formField}>
                  <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                  <div className={styles.labelTable}>{formatCurrency(this.props?.company?.[property])}</div>
                </div>
              </div>
            );
          })}

          {this.state.showDetails && (
            <div className={styles.containerTable}>
              <CreditInfoVehiclesTable company={this.props.company} />
            </div>
          )}
        </Card>
      </Container>
    );
  }
}

CompanyCreditInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyCreditInfoCard = compose(withConnect, withRouter)(CompanyCreditInfoCardComp);
